import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertService } from 'src/app/root/_services/alert.service';

@Component({
	selector: 'app-alert',
	templateUrl: './alert.component.html',
	styleUrls: ['./alert.component.scss']
})

export class AlertComponent implements OnInit, OnDestroy {

	private subscription: Subscription;
	message: any;
	timer;
	show: boolean;

	constructor(private alertService: AlertService) { }

	hideModal() {
		this.show = false;
	}

	ngOnInit() {
		this.subscription = this.alertService.getMessage().subscribe(message => {
			clearTimeout(this.timer);
			this.message = message;
			if (this.message) {
				this.show = true;
				this.timer = setTimeout(() => { this.show = false; }, 5000);
			}
		});

	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

}
